import React, { useState } from 'react'
import {
    Grid, Card, TextField, Button, makeStyles,
    FormControl, Select, MenuItem, InputLabel,
    Box, Chip, Typography, Container, InputAdornment,
    CircularProgress
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {
    Person as PersonIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    Home as HomeIcon,
    LocationCity as CityIcon,
    Cake as CakeIcon,
    Flag as FlagIcon
} from '@material-ui/icons';
import registration from "../../assets/images/registration.svg";
import bgLogo from "../../assets/images/bg.svg";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganization, registerUser } from '../../store/action';
import { apiClient } from '../../config/apiClient';
import { useForm } from 'react-hook-form';
import UtilService from '../../helper/service';
import Notify from '../../components/Notify/Notify';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(3),
        position: "relative",
        overflow: "hidden",
        "&::before": {
            content: '""',
            position: "absolute",
            width: "200%",
            height: "200%",
            top: "-50%",
            left: "-50%",
            zIndex: 0,
            background: `url(${bgLogo})`,
            backgroundSize: "contain",
            opacity: 0.05,
            transform: "rotate(-15deg)",
        },
    },
    container: {
        position: "relative",
        zIndex: 1,
    },
    authCard: {
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius * 2,
        overflow: "hidden",
        boxShadow: theme.shadows[8],
        maxHeight: 700,
        width: "100%",
    },
    leftPanel: {
        background: `linear-gradient(135deg, ${theme.palette.primary.light}20 0%, ${theme.palette.primary.main}20 100%)`,
        padding: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(4),
            borderRight: "none",
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
    },
    rightPanel: {
        padding: theme.spacing(5),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(3),
        },
    },
    form: {
        width: "100%",
    },
    inputIcon: {
        color: theme.palette.primary.main,
    },
    button: {
        borderRadius: theme.shape.borderRadius,
        height: 48,
        fontWeight: 600,
        marginTop: theme.spacing(2),
        background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        boxShadow: theme.shadows[2],
        "&:hover": {
            boxShadow: theme.shadows[4],
            background: `linear-gradient(45deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
        },
    },
    textField: {
        marginBottom: theme.spacing(2),
        "& .MuiOutlinedInput-root": {
            borderRadius: theme.shape.borderRadius,
            "&:hover fieldset": {
                borderColor: theme.palette.primary.light,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
                borderWidth: 1,
            },
        },
    },
    illustration: {
        width: "100%",
        height: "auto",
    },
    welcomeText: {
        textAlign: "center",
        color: theme.palette.primary.main,
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        textAlign: "center",
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(4),
    },
    stepIndicator: {
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(3),
    },
    stepCircle: {
        width: 30,
        height: 30,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: theme.spacing(0, 1),
        fontWeight: 600,
        fontSize: "0.875rem",
    },
    stepActive: {
        background: theme.palette.primary.main,
        color: "#fff",
    },
    stepInactive: {
        background: theme.palette.grey[300],
        color: theme.palette.text.secondary,
    },
    stepLine: {
        width: 40,
        height: 2,
        background: theme.palette.grey[300],
        margin: theme.spacing(0, 1),
        alignSelf: "center",
    },
    formControl: {
        marginBottom: theme.spacing(2),
        "& .MuiOutlinedInput-root": {
            borderRadius: theme.shape.borderRadius,
        },
    },
    specialityChip: {
        margin: theme.spacing(0.5),
        background: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
    },
    bottomLink: {
        textAlign: "center",
        marginTop: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
    registerLink: {
        color: theme.palette.primary.main,
        fontWeight: 600,
        textDecoration: "none",
        marginLeft: theme.spacing(0.5),
        "&:hover": {
            textDecoration: "underline",
        },
    },
    navigationButtons: {
        display: "flex",
        justifyContent: "space-between",
    },
    errorText: {
        color: theme.palette.error.main,
        fontSize: "0.75rem",
        marginTop: -8,
        marginBottom: theme.spacing(1),
    }
}));

const Register = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [count, setCount] = useState(0)
    const [speciality, setSpeciality] = useState([])
    const [personName, setPersonName] = React.useState([]);
    const { getOrglist } = useSelector(state => state.organization)
    const { registerErrors, registerSuccess, loading } = useSelector(state => state.authenticate)
    const [registerNotify, setRegisterNotify] = useState(false)
    
    // Use a single form instance for both steps
    const { register, handleSubmit, formState: { errors }, trigger, getValues } = useForm({
        mode: "onChange",
        reValidateMode: "onChange"
    });
    
    const [orgId, setOrgId] = useState()
    const disFutureDate = UtilService.disabledPastDate()

    const [data, setData] = useState({
        email: "",
        first_name: "",
        last_name: "",
        organization_id: "",
        speciality: [],
        contact_number: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        postcode: "",
        nmc_dmc_pin: "",
        candidate_referred_from: "",
        candidate_id: "",
        nationality: "",
        date_of_birth: "",
    })

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value });
    }

    const handleOrgChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value });
        setOrgId(event.target.value)
        setPersonName([])
    }

    useEffect(() => {
        dispatch(getOrganization())
    }, [dispatch])

    const getSpecialities = async () => {
        await apiClient(true).get(`api/signee/get-org-specialities/${orgId}`)
            .then(response => {
                setSpeciality(response.data.data)
            }).catch(error => {
                console.log('error: ', error);
            })
    }

    useEffect(() => {
        if (orgId) {
            getSpecialities()
        }
    }, [orgId])

    const getCandidateId = async () => {
        await apiClient(true).get(`api/signee/generate-candidateId`)
            .then(response => {
                setData({ ...data, candidate_id: parseFloat(response.data.data.candidate_id) })
            }).catch(error => {
                console.log("error.message", error.message);
            });
    }
    
    useEffect(() => {
        getCandidateId()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Validate step 1 fields before proceeding
    const handleNextStep = async () => {
        // Validate all fields in step 1
        const isValid = await trigger([
            "first_name", 
            "last_name", 
            "email", 
            "contact_number", 
            "address_line_1", 
            "city", 
            "postcode"
        ]);
        
        if (isValid) {
            setCount(count + 1);
        }
    };

    const handleSubmitRegistration = () => {
        dispatch(registerUser(data))
        setRegisterNotify(true)
    }

    const handleChange2 = (event) => {
        const { target: { value } } = event;
        setPersonName(typeof value === 'string' ? value.split(',') : value);
        setData({ ...data, speciality: value });
    };

    return (
        <>
            {registerNotify && (registerErrors?.message || registerErrors) && (
                <Notify
                    data={registerErrors?.message ? registerErrors?.message : registerErrors}
                    status="error"
                />
            )}
            {registerNotify && registerSuccess?.message && (
                <Notify
                    data={registerSuccess?.message}
                    status="success"
                />
            )}
            
            <Box className={classes.root}>
                <Container maxWidth="lg" className={classes.container}>
                    <Card className={classes.authCard}>
                        <Grid container alignItems="center">
                            {/* Left Section - Illustration */}
                            <Grid item xs={12} md={6} className={classes.leftPanel}>
                                <img
                                    src={registration}
                                    alt="Registration Illustration"
                                    className={classes.illustration}
                                />
                                <Typography variant="h4" className={classes.welcomeText} gutterBottom>
                                    Join Us Today
                                </Typography>
                                <Typography variant="body1" className={classes.subtitle}>
                                    Create your account and start your journey with us
                                </Typography>
                            </Grid>

                            {/* Right Section - Form */}
                            <Grid item xs={12} md={6} className={classes.rightPanel}>
                                <Typography variant="h5" gutterBottom color="primary">
                                    Create Your Account
                                </Typography>
                                
                                {/* Step Indicator */}
                                <Box className={classes.stepIndicator}>
                                    <div className={`${classes.stepCircle} ${count >= 0 ? classes.stepActive : classes.stepInactive}`}>
                                        1
                                    </div>
                                    <div className={classes.stepLine}></div>
                                    <div className={`${classes.stepCircle} ${count >= 1 ? classes.stepActive : classes.stepInactive}`}>
                                        2
                                    </div>
                                </Box>

                                <Box className={classes.registerCard}>
                                    {count === 0 && (
                                        <form className={classes.form}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        autoFocus
                                                        required
                                                        name="first_name"
                                                        placeholder="First Name"
                                                        variant="outlined"
                                                        error={!!errors.first_name}
                                                        {...register("first_name", { 
                                                            required: "First name is required" 
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <PersonIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                    {errors.first_name && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.first_name.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        name="last_name"
                                                        placeholder="Last Name"
                                                        variant="outlined"
                                                        error={!!errors.last_name}
                                                        {...register("last_name", { 
                                                            required: "Last name is required" 
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <PersonIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                    {errors.last_name && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.last_name.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        name="email"
                                                        placeholder="Email Address"
                                                        variant="outlined"
                                                        error={!!errors.email}
                                                        {...register("email", {
                                                            required: "Email is required",
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                message: "Invalid email address",
                                                            },
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <EmailIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                    {errors.email && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.email.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        name="contact_number"
                                                        placeholder="Contact Number"
                                                        variant="outlined"
                                                        error={!!errors.contact_number}
                                                        {...register("contact_number", { 
                                                            required: "Contact number is required" 
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <PhoneIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                    {errors.contact_number && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.contact_number.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        name="address_line_1"
                                                        placeholder="Address Line 1"
                                                        variant="outlined"
                                                        error={!!errors.address_line_1}
                                                        {...register("address_line_1", { 
                                                            required: "Address is required" 
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <HomeIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                    {errors.address_line_1 && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.address_line_1.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        name="address_line_2"
                                                        placeholder="Address Line 2 (Optional)"
                                                        variant="outlined"
                                                        {...register("address_line_2")}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <HomeIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        name="city"
                                                        placeholder="City"
                                                        variant="outlined"
                                                        error={!!errors.city}
                                                        {...register("city", { 
                                                            required: "City is required" 
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <CityIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                    {errors.city && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.city.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        name="postcode"
                                                        placeholder="Postcode"
                                                        variant="outlined"
                                                        error={!!errors.postcode}
                                                        {...register("postcode", { 
                                                            required: "Postcode is required" 
                                                        })}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        fullWidth
                                                    />
                                                    {errors.postcode && (
                                                        <Typography className={classes.errorText}>
                                                            {errors.postcode.message}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        name="nationality"
                                                        placeholder="Nationality"
                                                        variant="outlined"
                                                        {...register("nationality")}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <FlagIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        placeholder="Date of Birth"
                                                        type="date"
                                                        name="date_of_birth"
                                                        variant="outlined"
                                                        {...register("date_of_birth")}
                                                        onChange={handleChange}
                                                        InputLabelProps={{ shrink: true }}
                                                        className={classes.textField}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <CakeIcon className={classes.inputIcon} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        inputProps={{ max: disFutureDate }}
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Box className={classes.navigationButtons}>
                                                <div></div>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    endIcon={<ArrowForwardIosIcon />}
                                                    onClick={handleNextStep}
                                                >
                                                    Next
                                                </Button>
                                            </Box>
                                        </form>
                                    )}

                                    {count === 1 && (
                                        <form className={classes.form} onSubmit={handleSubmit(handleSubmitRegistration)}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <FormControl
                                                        variant="outlined"
                                                        className={classes.formControl}
                                                        error={!!errors.organization_id}
                                                        fullWidth
                                                        {...register("organization_id", { 
                                                                required: "Organization is required" 
                                                            })}
                                                    >
                                                        <InputLabel>Select Organization</InputLabel>
                                                        <Select
                                                            value={data?.organization_id || ""}
                                                            label="Select Organization"
                                                            onChange={handleOrgChange}
                                                            name="organization_id"
                                                            
                                                        >
                                                            <MenuItem value="">Select Organization</MenuItem>
                                                            {getOrglist?.data && getOrglist.data.map((list, index) => (
                                                                <MenuItem value={list.id} key={index}>
                                                                    {list.organization_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {errors.organization_id && (
                                                            <Typography className={classes.errorText}>
                                                                {errors.organization_id.message}
                                                            </Typography>
                                                        )}
                                                        <Typography variant="caption" color="textSecondary">
                                                            Select an organization wherein you want to work
                                                        </Typography>
                                                    </FormControl>
                                                </Grid>

                                                {speciality?.length > 0 && orgId && (
                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth variant="outlined" className={classes.formControl}>
                                                            <InputLabel>Specialities</InputLabel>
                                                            <Select
                                                                label="Specialities"
                                                                multiple
                                                                value={personName}
                                                                onChange={handleChange2}
                                                                name="speciality"
                                                                renderValue={(selected) => (
                                                                    <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                        {selected.map((value) => {
                                                                            const specialityItem = speciality.find(item => item.id === value);
                                                                            return specialityItem ? (
                                                                                <Chip
                                                                                    key={value}
                                                                                    label={specialityItem.speciality_name}
                                                                                    className={classes.specialityChip}
                                                                                    size="small"
                                                                                />
                                                                            ) : null;
                                                                        })}
                                                                    </Box>
                                                                )}
                                                            >
                                                                {speciality.map((item) => (
                                                                    <MenuItem key={item.id} value={item.id}>
                                                                        {item.speciality_name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                )}

                                                <Grid item xs={12}>
                                                    <TextField
                                                        name="nmc_dmc_pin"
                                                        placeholder="Registered Body Pin (Optional)"
                                                        variant="outlined"
                                                        {...register("nmc_dmc_pin")}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Box className={classes.navigationButtons}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => setCount(count - 1)}
                                                    startIcon={<ArrowBackIosIcon />}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    disabled={loading}
                                                >
                                                    {loading ? <CircularProgress size={24} color="inherit" /> : "Register"}
                                                </Button>
                                            </Box>
                                        </form>
                                    )}
                                </Box>

                                <Typography className={classes.bottomLink}>
                                    Already have an account?{" "}
                                    <Link to="/login" className={classes.registerLink}>
                                        Login
                                    </Link>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Card>
                </Container>
            </Box>
        </>
    )
}

export default Register